import React, { useState, useEffect } from "react";
import { Menu, X, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Button } from "@/components/ui/button";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { cn } from "@/lib/utils";
function HeaderMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="hidden md:flex gap-6">
        {[1, 2, 3, 4].map(i => <div key={i} data-index={i} className="h-4 w-16 bg-muted/20 animate-pulse rounded-sm" />)}
      </div>;
  }
  return <NavigationMenu viewport={false} className="hidden md:flex">
      <NavigationMenuList className="gap-6">
        {menuItems.slice(0, 5).map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
            <NavigationMenuLink asChild>
              <Link to={item.href || "#"} className="text-xs font-medium uppercase tracking-[1px] text-[#c5a059] hover:text-white hover:bg-transparent transition-colors duration-300 font-sans px-2 whitespace-nowrap">
                {item.label}
              </Link>
            </NavigationMenuLink>
          </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
function MobileMenuConsumer({
  onClose
}: {
  onClose: () => void;
}) {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) return null;
  return <nav className="flex flex-col items-center justify-center gap-8 p-8">
      {menuItems.slice(0, 5).map((item, i) => <Link key={item.id} data-index={i} to={item.href || "#"} className="text-2xl font-medium uppercase tracking-widest text-[#c5a059] hover:text-white transition-colors" onClick={onClose}>
          {item.label}
        </Link>)}
    </nav>;
}
export default function KurumsalKimlikBasligi() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest('a[href]') as HTMLAnchorElement | null;
      if (anchor) {
        const href = anchor.getAttribute('href');
        if (!href) return;
        let hash = '';
        if (href.startsWith('#')) {
          hash = href;
        } else if (href.startsWith('/') && href.includes('#')) {
          const [path, hashPart] = href.split('#');
          if (path === '/' || path === window.location.pathname) {
            hash = '#' + hashPart;
          }
        }
        if (hash && hash !== '#') {
          const element = document.querySelector(hash);
          if (element) {
            e.preventDefault();
            element.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
            setIsMobileMenuOpen(false);
          }
        }
      }
    };
    document.addEventListener('click', handleAnchorClick);
    return () => document.removeEventListener('click', handleAnchorClick);
  }, []);
  return <header id="kurumsal-kimlik-başlığı" className={cn("sticky top-0 z-50 w-full transition-all duration-500 border-b border-transparent dark", isScrolled ? "bg-[#0a0c10]/95 backdrop-blur-lg border-white/5 shadow-md" : "bg-[#0a0c10]")}>
      <div className="container mx-auto px-6 h-24 flex items-center justify-between">
        
        <Link to="https://celikhukuk.net/" className="flex-shrink-0 z-50">
          <span className="text-xs font-serif font-medium tracking-wide text-[#b0b0b0] uppercase leading-tight block max-w-[300px] md:max-w-none">
            AV. ARB. MUHAMMED ÇELİK HUKUK VE ARABULUCULUK BÜROSU
          </span>
        </Link>

        <div className="hidden md:flex items-center justify-center flex-1 px-4">
          <MenuProvider menu_id="45">
            <HeaderMenuConsumer />
          </MenuProvider>
        </div>

        <Button asChild className="md:hidden bg-[#0a192f] text-[#c5a059] hover:bg-[#0a192f]/90 border border-[#c5a059]/20 z-50 ml-auto mr-2 h-9 px-4">
          <Link to="tel:+905548421537" className="flex items-center gap-2">
            <Phone className="size-4" />
            <span className="text-xs font-bold tracking-wider uppercase">Ara</span>
          </Link>
        </Button>

        <Button variant="ghost" size="icon" className="md:hidden text-[#b0b0b0] hover:bg-white/10 z-50" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Menüyü Aç">
          {isMobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </Button>

        <div className={cn("fixed inset-0 bg-[#0a0c10] z-40 flex flex-col items-center justify-center transition-all duration-500 md:hidden", isMobileMenuOpen ? "opacity-100 visible" : "opacity-0 invisible pointer-events-none")}>
          <MenuProvider menu_id="45">
            <MobileMenuConsumer onClose={() => setIsMobileMenuOpen(false)} />
          </MenuProvider>
          
          <div className="mt-8 pt-8 border-t border-white/10 w-24 flex justify-center">
             <Link to="/CorporatePage" className="text-sm font-medium uppercase tracking-widest text-[#b0b0b0]" onClick={() => setIsMobileMenuOpen(false)}>
               KURUMSAL
             </Link>
          </div>
        </div>
      </div>
    </header>;
}